import React from 'react';
import { AbsoluteFill, Audio, Sequence, useVideoConfig } from 'remotion';

import { CaptionsDisplay } from './captions/CaptionsDisplay';
import { Background } from './components/Background';
import { Header } from './components/Header';
import { AudiogramProps } from './schema';
import { Visualizer } from './visualizer/Visualizer';

export const Audiogram: React.FC<AudiogramProps> = (props) => {
  const { audioFileUrl, audioOffsetInSeconds } = props;
  const { fps } = useVideoConfig();

  return (
    <AbsoluteFill>
      <Sequence from={-Math.round(audioOffsetInSeconds * fps)}>
        <Audio pauseWhenBuffering src={audioFileUrl} />
        <Background {...props}>
          <Header {...props} />
          <Visualizer {...props} />
          <CaptionsDisplay {...props} />
        </Background>
      </Sequence>
    </AbsoluteFill>
  );
};
